<div class="charity-profile-card">
  <!-- Header Section with Logo, Name, and Status -->
  <div class="charity-profile-card__header" [class.charity-profile-card__header--unavailable]="isUnavailableState()">
    <div class="charity-profile-card__header-content">
      <div class="charity-profile-card__logo-container">
        @if (isUnavailableState()) {
          <div
            class="charity-profile-card__user-icon"
            [innerHTML]="getSafeUserIcon()"></div>
        } @else {
          <img
            [src]="charityLogo()"
            [alt]="charityName()"
            class="charity-profile-card__logo"
          />
        }
      </div>

      @if (isUnavailableState()) {
        <div class="charity-profile-card__info">
          <p class="charity-profile-card__name">{{ titleKey() | translateLang }}</p>
          <p class="charity-profile-card__subtitle">{{ subtitleKey() | translateLang }}</p>
        </div>
      } @else {
        <p class="charity-profile-card__name">{{ charityName() }}</p>
        @if (showStatus()) {
          <div class="charity-profile-card__status charity-profile-card__status--{{ status() | lowercase }}">
            <p class="charity-profile-card__status-text">{{ status() | lowercase }}</p>
          </div>
        }
      }
    </div>

  </div>

  <!-- Divider Line -->
  <div class="charity-profile-card__divider"></div>

  <!-- Content Section with Message and Button -->
  <div class="charity-profile-card__content">
    @if (isUnavailableState()) {
      <p class="charity-profile-card__message">{{ messageKey() | translateLang }}</p>
      <p class="charity-profile-card__message charity-profile-card__message--secondary">
        {{ secondaryMessageKey() | translateLang }}
      </p>
    } @else {
      <p class="charity-profile-card__message">{{ messageKey() | translateLang }}</p>
    }

    <button
      class="charity-profile-card__button"
      (click)="onButtonClick()"
      type="button"
    >
      {{ buttonTextKey() | translateLang }}
    </button>
  </div>
</div>
